// extracted by mini-css-extract-plugin
module.exports = {"content":"AcademyHero_content__in_ah"};